import {Command} from "../command";
import {CommandType} from "../commandType";
import * as $ from "jquery";
import {PopupType} from "../popups/popupType";
import {Application} from "../application";
import * as ko from "knockout";
import {CustomerInfoPopupParams, PopupMode} from "../../components/customer-info-popup/customer-info-popup";

export class OpenCustomerInfoPopupCommand implements Command {
    constructor(private app: Application) {

    }

    type: CommandType = CommandType.OpenCustomerInfoPopup;
    canExecute = ko.computed(() => {
        return this.app.state.estimate() != undefined;
    });
    canNotExecute = ko.computed(() => {
        return !this.canExecute();
    });
    execute(): JQueryPromise<any> {
        if (!this.canExecute())
            return $.Deferred().reject().promise();

        return this.app.popupsManager.show<CustomerInfoPopupParams>(PopupType.customerInfo, false, { mode: PopupMode.CustomerInfo});
    }

    name = "Edit Customer Info";
}


// WEBPACK FOOTER //
// ./ClientApp/services/commands/openCustomerInfoPopupCommand.ts